import { FileUpload } from '../../../../models/Entities/Contracts/FileUpload';
import { ErrorType } from '../../../../models/HttpError';
import { AppState } from '../../../../redux/reducers';
import { FileUploadFilters } from '../../../../models/Filters/FileUploadFilters';

// Action creators
import * as FileUploadStore from '../../../../redux/middleware/FileUploadMiddleware';

//#region Props

/**
 * Base component props
 */
interface IProps {
  ContractId: number;
  entityType?: string;
  viewMode?: 'grid' | 'list'; // Opciones de visualización: grid (por defecto) o list (minimalista)
}

/**
 * Props connected from Redux state
 */
interface ConnectedProps {
  // List state
  FileUploads: FileUpload[];
  TotalCount: number;
  
  // Loading state
  isLoadingAll: boolean;
  successLoadingAll: boolean | undefined;
  failOnLoadingAll: boolean;
  
  // Upload state
  isUploadingFile: boolean;
  successUploadingFile: boolean | undefined;
  failOnUploadingFile: boolean;
  
  // Download state
  isDownloadingFile: boolean;
  successDownloadingFile: boolean | undefined;
  failOnDownloadingFile: boolean;
  
  // Update state
  isUpdatingFile: boolean;
  successUpdatingFile: boolean | undefined;
  failOnUpdatingFile: boolean;

  // Deletion state
  isDeletingFile: boolean;
  successDeletingFile: boolean | undefined;
  failOnDeletingFile: boolean;
  
  // Error state
  error?: ErrorType;
}

/**
 * Props mapped from action creators
 */
interface DispatchProps {
  GetAllFileUploads: (filters?: FileUploadFilters) => void; 
  UploadFile: (data: FileUpload) => void;
  DownloadFile?: (fileId: number) => void;
  UpdateFileUpload?: (fileId: number, data: Partial<FileUpload>) => void;
  DeleteFileUpload?: (fileId: number) => void;
  SetEditingFileUpload?: (file?: FileUpload) => void;
}

export type Props = IProps & ConnectedProps & DispatchProps;

/**
 * Maps Redux state to component props
 */
export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    // Data props
    FileUploads: state.FileUpload?.FileUploads || [],
    TotalCount: state.FileUpload?.TotalCount ?? 0,
    
    // Loading states
    isLoadingAll: state.FileUpload?.isLoadingAll || false,
    successLoadingAll: state.FileUpload?.successLoadingAll,
    failOnLoadingAll: state.FileUpload?.failOnLoadingAll || false,
    
    // Upload states
    isUploadingFile: state.FileUpload?.isUploadingFile || false,
    successUploadingFile: state.FileUpload?.successUploadingFile,
    failOnUploadingFile: state.FileUpload?.failOnUploadingFile || false,
    
    // Download states
    isDownloadingFile: state.FileUpload?.isDownloadingFile || false,
    successDownloadingFile: state.FileUpload?.successDownloadingFile,
    failOnDownloadingFile: state.FileUpload?.failOnDownloadingFile || false,
    
    // Update states
    isUpdatingFile: state.FileUpload?.isUpdatingFile || false,
    successUpdatingFile: state.FileUpload?.successUpdatingFile,
    failOnUpdatingFile: state.FileUpload?.failOnUpdatingFile || false,

    // Delete states
    isDeletingFile: state.FileUpload?.isDeletingFile || false,
    successDeletingFile: state.FileUpload?.successDeletingFile,
    failOnDeletingFile: state.FileUpload?.failOnDeletingFile || false,
    
    // Error state
    error: state.FileUpload?.error
});

/**
 * Maps action creators to component props
 */
export const mapDispatchToProps = {
    ...FileUploadStore.actionCreators
};